const shared = {}

export default shared
